var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2816 7.5H8.59406C7.99026 7.5 7.5 7.99026 7.5 8.59406V11.4066C7.5 12.0094 7.99026 12.5006 8.59406 12.5006H13.2816C13.8844 12.5006 14.3756 12.0103 14.3756 11.4066V8.59406C14.3747 7.99026 13.8844 7.5 13.2816 7.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2816 13.7503H8.59406C7.99026 13.7503 7.5 14.2406 7.5 14.8434V21.4059C7.5 22.0097 7.99026 22.5 8.59406 22.5H13.2816C13.8844 22.5 14.3756 22.0097 14.3756 21.4059V14.8434C14.3747 14.2406 13.8844 13.7503 13.2816 13.7503Z",
    fill: "var(--ion-color-primary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4061 17.5003H16.7186C16.1157 17.5003 15.6245 17.9906 15.6245 18.5944V21.4069C15.6245 22.0097 16.1148 22.5009 16.7186 22.5009H21.4061C22.0099 22.5 22.5001 22.0097 22.5001 21.4059V18.5934C22.5001 17.9906 22.0099 17.5003 21.4061 17.5003Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4061 7.5H16.7186C16.1157 7.5 15.6245 7.99026 15.6245 8.59406V15.1566C15.6245 15.7594 16.1148 16.2506 16.7186 16.2506H21.4061C22.0089 16.2506 22.5001 15.7603 22.5001 15.1566V8.59406C22.5001 7.99026 22.0099 7.5 21.4061 7.5Z",
    fill: "var(--ion-color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bc0c3c4f.svg";
export { ForwardRef as ReactComponent };